import React from 'react';
import Response from './responces/Response';
import Form from './responces/Form';
import {inject, observer} from 'mobx-react';
import {RESPONSE_ANSWERED_KEY} from '../constants';
import QuillEditor from 'components/create_workshop/QuillEditor';

@inject('workshopDetails')
@observer

export default class QuestionDetails extends React.Component {

  state = {formActive: false,
    response: {text: '', documents: [], attachments_attributes: [] }
  };


  render(){

    let question = this.props.workshopDetails.workshop.modules[this.props.moduleId].questions[this.props.questionId];
    const lastAnswerKey = (question.answers && question.answers.length > 0)  ? RESPONSE_ANSWERED_KEY[question.answers.slice(-1)[0].answer_score] : '';

    return(<div className="question-accordion-content">
      <div className="question-accordion-content-holder" style={{paddingLeft: 0}} >
        <div style={{marginBottom: '50px', marginTop: '20px' }}>

            <QuillEditor
              theme={null}
              value={question.text || ""}
              readOnly={true}
            />
          </div>
          {question.attachments.length !== 0 &&
            <ul className="file-list editing attachments-file ">

              {question.attachments.map((el, index) =>
                <a href={el.document_url} download={true} className="file-link-active" key={index}>

                <li className="file-item">
                  <div className="file-item-inner" style={{height: '50px'}}>
                    <i className="ic-file-ico file-icon"/>
                    <div className="file-link">
                    {el.document_file_name}
                      <span className="file-link-size">{parseInt(el.document_file_size / 1024)} KB</span>
                    </div>
                  </div>
                </li>
                </a>
              )}
            </ul>
          }

        { this.props.workshopDetails.role &&
        [<div key={1} className="answers">{question.answers.map(el => <Response question={question}
                                                                                key={el.id}
                                                                                el={el}
                                                                                moduleId={this.props.moduleId}/>) }</div>,
            <Form key={2}
                  moduleId={this.props.moduleId}
                  question_id={question.id}
                  data={this.state.response}
                  submit={this.submit}
                  workshop_id={this.props.workshopDetails.workshop.id}
                  transaction_id={this.props.workshopDetails.workshop.transaction_id}
                  last_answer_key={lastAnswerKey}
                  />]

        }

      </div>


    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/question/QuestionDetails.jsx